import React from 'react';
import ShopSection from '../components/ShopSection';
import Footer from '../components/Footer';
import './Shop.css';

const Shop = () => {
  return (
    <div className="shop-page">
      <ShopSection />
      <Footer />
    </div>
  );
};

export default Shop;

